import * as React from 'react';

/**
 * Runs a stock Amplify v3 screen's own render from inside a subclass.
 *
 * Supplying custom components to the Authenticator turns on `hideDefault`,
 * which pushes every built-in screen onto a `hide` list and then removes the
 * ones whose class exactly matches a supplied child. Our screens are
 * *subclasses*, so they never match, and the base class stays on the list —
 * where each stock `showComponent` finds itself and returns null.
 *
 * So the base render is invoked with that one entry stripped from `hide`.
 * `this.props` is swapped for the duration of the synchronous call and always
 * restored; React never reads it in between.
 */
export function renderStockScreen(
  component: React.Component<any, any>,
  baseClass: any,
  render: () => React.ReactNode,
): React.ReactNode {
  const originalProps = component.props;
  const hide: any[] = originalProps.hide || [];
  if (!hide.includes(baseClass)) {
    return render();
  }

  (component as any).props = {
    ...originalProps,
    hide: hide.filter(entry => entry !== baseClass),
  };
  try {
    return render();
  } finally {
    (component as any).props = originalProps;
  }
}
